import { notification } from "antd";
import { action, makeAutoObservable } from "mobx";
import { Api } from "../../../common/Api";
import { ArticlesStore } from "./ArticlesStore";

export class ArticleEditStore {
  store: ArticlesStore;
  showDlg = false;
  loading = false;
  saving = false;
  model: any;
  publishing = false;

  types = ["Deals", "Blog", "FAQ-Community", "FAQ-PS Offer", "FAQ-PS Request"];

  constructor(store: ArticlesStore) {
    makeAutoObservable(this, {});
    this.store = store;
  }

  @action show(model?, publishing = false) {
    this.publishing = publishing;
    this.model = model;
    this.showDlg = true;
  }
  @action close() {
    this.showDlg = false;
  }

  @action save(values) {
    this.saving = true;
    Api.content.article
      .save({ ...this.model, ...values })
      .then((res) => {
        notification.success({ message: "Success!" });
        if (this.publishing) {
          this.store.publishStore.updateArticle(values);
        }
        setTimeout(() => {
          this.store.refresh();
        }, 3000);
        this.showDlg = false;
      })
      .finally(() => (this.saving = false));
  }
}
